// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: '/auth',
  HOME: '/trang-chu',
};

// ----------------------------------------------------------------------

export const paths = {
  // GUEST
  guest: {
    tra_cuu: '/tra-cuu',
    chi_tiet_sach: (id: any) => `/tra-cuu/${id}`,
    gio_sach: '/gio-sach',
    dat_truoc: '/dat-truoc',
    dang_ky_the: '/dang-ky-the',
    xac_nhan_dang_ky: (token: string) => `/xac-nhan-dang-ky-muon/${token}`,
  },

  // AUTH
  auth: {
    jwt: {
      login: `${ROOTS.AUTH}/login`,
    },
  },

  // READER
  danh_cho_ban_doc: {
    root: '/danh-cho-ban-doc',
    tra_cuu: '/danh-cho-ban-doc/tra-cuu',
    dien_dan: '/danh-cho-ban-doc/dien-dan',
    chi_tiet_dien_dan: (id: any) => `/danh-cho-ban-doc/dien-dan/chi-tiet/${id}`,
    dong_gop_an_pham: {
      root: '/danh-cho-ban-doc/dong-gop-an-pham',
      danh_sach: '/danh-cho-ban-doc/dong-gop-an-pham/danh-sach',
      tao: '/danh-cho-ban-doc/dong-gop-an-pham/tao',
    },
  },
  // HOME
  home: {
    root: ROOTS.HOME,
    trang_chu: ROOTS.HOME,
  },
  bao_cao: {
    root: `/bao-cao`,
    muon_tra: `/bao-cao/bao-cao-muon-tra`,
    ban_doc: `/bao-cao/bao-cao-ban-doc`,
    an_pham: `/bao-cao/bao-cao-an-pham`,
  },
  lop_hoc: {
    root: `/lop-hoc`,
    danh_sach: `/lop-hoc/danh-sach-lop-hoc`,
    nien_khoa: `/lop-hoc/nien-khoa-lop-hoc`,
    chuyen_nganh: `/lop-hoc/chuyen-nganh-lop-hoc`,
  },
  an_pham: {
    root: `/an-pham`,
    danh_sach: `/an-pham/danh-sach-an-pham`,
    nha_xuat_ban: `/an-pham/nha-xuat-ban-an-pham`,
    danh_muc: `/an-pham/danh-muc-an-pham`,
    linh_vuc: `/an-pham/linh-vuc-an-pham`,
    ngon_ngu: `/an-pham/ngon-ngu-an-pham`,
    tinh_trang: `/an-pham/tinh-trang-an-pham`,
  },
  ban_doc: {
    root: `/ban-doc`,
    danh_sach: `/ban-doc/danh-sach-ban-doc`,
    nhom: `/ban-doc/nhom-ban-doc`,
  },
  muon_tra: {
    root: `/muon-tra`,
    danh_sach: `/muon-tra/danh-sach-muon-tra`,
    qua_han: `/muon-tra/danh-sach-qua-han`,
    phieu_phat: `/muon-tra/danh-sach-phieu-phat`,
  },
  kho_ke: {
    root: `/kho-ke`,
    // kho_hang: `/kho-ke/danh-sach-kho-hang`,
    ke_hang: `/kho-ke/danh-sach-ke-hang`,
    // gia_dung: `/kho-ke/danh-sach-gia-dung`,
    vi_tri: `/kho-ke/vi-tri-luu-tru`,
  },
  phi_phat: {
    root: `/phi-phat`,
    // phi_phat: `/phi-phat/danh-sach-phi-phat`,
    danh_sach: `/phi-phat/danh-sach-phi-phat`,
    // chi_tiet_phat: `/phi-phat/chi-tiet-phat`,
    chi_tiet_phat: `/phi-phat/chi-tiet-phat`,
  },
  dk_muon_truoc: {
    root: `/dk-muon-truoc`,

    danh_sach: `/dk-muon-truoc/danh-sach-dk-muon-truoc`,
  },
  yeu_cau: {
    root: `/yeu-cau`,

    danh_sach: `/yeu-cau/danh-sach-yeu-cau`,
  },
  mat_sach: {
    root: `/mat-sach`,

    danh_sach: `/mat-sach/danh-sach-mat-sach`,
  },
  phi_mo_the: {
    root: `/phi-mo-the`,

    danh_sach: `/phi-mo-the/danh-sach-phi-mo-the`,
  },
  dang_ky_mo_the: {
    root: `/dang-ky-mo-the`,
    danh_sach: `/dang-ky-mo-the/danh-sach-dang-ky-mo-the`,
  },

  // nhap_xuat: {
  //   root: `/nhap-xuat`,
  //   phieu_nhap: `/nhap-xuat/danh-sach-phieu-nhap`,
  //   phieu_xuat: `/nhap-xuat/danh-sach-phieu-xuat`,
  // },
  // chat_ai: {
  //   root: `/chat-ai`,
  // },
  // chuyen_doi: {
  //   root: `/chuyen-doi`,
  //   van_ban_thanh_giong_noi: `/chuyen-doi/van-ban-thanh-giong-noi`,
  //   giong_noi_thanh_van_ban: `/chuyen-doi/giong-noi-thanh-van-ban`,
  // },

  quyen_han: {
    root: `/quyen-han`,
    danh_sach: `/quyen-han/danh-sach-chuc-nang`,
    danh_sach_cac_quyen: `/quyen-han/danh-sach-cac-quyen`,
  },
  nguoi_dung: {
    root: `/nguoi-dung`,
    danh_sach: `/nguoi-dung/danh-sach-nguoi-dung`,
    danh_sach_tai_khoan: `/nguoi-dung/danh-sach-tai-khoan`,
  },

  truong_hoc: {
    root: `/truong-hoc`,
  },
  cai_dat: {
    root: `/cai-dat`,
  },
};
